import React, { Component } from 'react'
import { compose } from 'recompose'

import { ParticipantAward } from 'containers/sections/awards'
import { meta, routerAdapter } from 'helpers/decorators'

const enhance = compose(
  meta({
    title: 'Gold level',
    intlKey: 'route.gold_level',
    noOverride: true
  })
)

@routerAdapter()
class ParticipantGoldLevel extends Component {
  render() {
    return (
      <ParticipantAward {...this.props} decoFilter="participantsGoldAwards" />
    )
  }
}

export default enhance(ParticipantGoldLevel)
